import styled from 'styled-components';

export const StyledFarmUserMobileList = styled.div`
  .mobile-list-card-body-item {
    padding-bottom: 9px;
    border-bottom: 1px solid ${({ theme }) => theme.silverGray};

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }

    span {
      font-size: 0.875rem;
    }
  }

  .mobile-list-card-cover-item {
    font-size: 0.875rem;
  }
`;
